enum NetworkAnalyticsEvent {
  NetworkStatusChanged = "Network Status Changed",
}

export { NetworkAnalyticsEvent };
